var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalization({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "358px",
    height: "200px",
    viewBox: "0 0 358 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L352,0 C355.313708,-6.08718376e-16 358,2.6862915 358,6 L358,200 L358,200 L0,200 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L97.2767426,0 C101.695021,-8.11624501e-16 105.276743,3.581722 105.276743,8 L105.276743,198.72877 C105.276743,208.958188 96.9841607,217.25077 86.7547426,217.25077 L18.522,217.25077 C8.29258186,217.25077 3.33326917e-14,208.958188 3.20799493e-14,198.72877 L3.20799493e-14,8 C3.15388663e-14,3.581722 3.581722,8.11624501e-16 8,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.1440503%",
    y1: "57.4560851%",
    x2: "171.027698%",
    y2: "78.5499955%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D63A0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222735",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.4922248%",
    y1: "44.1679326%",
    x2: "69.1530929%",
    y2: "58.7916097%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7FFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#648BF0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Knowledge-Base",
    transform: "translate(-288.000000, -791.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(288.000000, 791.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone1",
    transform: "translate(85.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L101.863144,0 C108.490561,2.89253516e-15 113.863144,5.372583 113.863144,12 L113.863144,209.711288 C113.863144,223.594069 102.608925,234.848288 88.7261436,234.848288 L25.137,234.848288 C11.2542182,234.848288 1.293343e-14,223.594069 -1.60399746e-14,209.711288 L-1.60399746e-14,12 C-1.8627956e-14,5.372583 5.372583,-5.58920087e-16 12,0 Z",
    id: "Rectangle",
    fill: "#BCF8FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(4.106540, 10.341122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.6182386,3.83102184 C68.5922557,3.83102184 69.3818525,4.58433748 69.3818525,5.51359941 C69.3818525,6.42221107 68.626959,7.16260939 67.6828933,7.19506728 L67.6182386,7.19617697 L36.3889585,7.19617697 C35.4149414,7.19617697 34.6253446,6.44286134 34.6253446,5.51359941 C34.6253446,4.60498774 35.3802382,3.86458942 36.3243039,3.83213153 L36.3889585,3.83102184 L67.6182386,3.83102184 Z",
    id: "Path",
    fill: "#56CDD9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.354305,3.55059225 C74.328322,3.55059225 75.1179189,4.33529603 75.1179189,5.30327721 C75.1179189,6.24974769 74.3630253,7.02099594 73.4189596,7.05480625 L73.354305,7.05596217 L73.261803,7.05596217 C72.287786,7.05596217 71.4981891,6.27125839 71.4981891,5.30327721 C71.4981891,4.35680673 72.2530827,3.58555848 73.1971484,3.55174817 L73.261803,3.55059225 L73.354305,3.55059225 Z",
    id: "Path",
    fill: "#56CDD9",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(208.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L20.4548734,0 L20.4548734,0 L27,6.73684211 L27,26 C27,29.3137085 24.3137085,32 21,32 L6,32 C2.6862915,32 4.05812251e-16,29.3137085 0,26 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "Rectangle",
    fill: "#AEDDF9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(6.187500, 10.666667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.97636414,12.8842149 C4.46753296,12.8842149 5.67636414,11.6777401 5.67636414,10.189478 C5.67636414,8.70121598 4.46753296,7.4947412 2.97636414,7.4947412 C1.48519531,7.4947412 0.276364137,8.70121598 0.276364137,10.189478 C0.276364137,11.6777401 1.48519531,12.8842149 2.97636414,12.8842149 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45,11.7211317 C10.9411688,11.7211317 12.15,10.5146569 12.15,9.02639484 C12.15,7.53813278 10.9411688,6.331658 9.45,6.331658 C7.95883118,6.331658 6.75,7.53813278 6.75,9.02639484 C6.75,10.5146569 7.95883118,11.7211317 9.45,11.7211317 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "12.15 0.338896931 12.15 8.82363643 11.1375 8.82363643 11.1370879 2.40172234 5.6682379 4.17081708 5.6682379 10.1086664 4.6557379 10.1086664 4.65625925 2.76250214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27,6.73684211 L23.4548734,6.73684211 C21.7980191,6.73684211 20.4548734,5.39369635 20.4548734,3.73684211 L20.4548734,0 L20.4548734,0 L27,6.73684211 Z",
    id: "Path",
    fill: "#4EA3D6",
    fillRule: "nonzero",
    opacity: 0.339960007
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(142.500000, 90.500000) scale(-1, 1) translate(-142.500000, -90.500000) translate(107.500000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25376,0 L58.99264,0 C64.9308056,-1.09082333e-15 69.74464,4.81383437 69.74464,10.752 L69.74464,69.888 C69.74464,75.8261656 64.9308056,80.64 58.99264,80.64 L11.25376,80.64 C5.31559437,80.64 0.50176,75.8261656 0.50176,69.888 L0.50176,10.752 C0.50176,4.81383437 5.31559437,-6.8553351e-16 11.25376,0 Z",
    id: "Rectangle",
    fill: "#B8E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73213,6.048 L54.73027,6.048 C59.6971048,6.048 63.72352,10.0744152 63.72352,15.04125 C63.72352,20.0080848 59.6971048,24.0345 54.73027,24.0345 L14.73213,24.0345 C9.76529517,24.0345 5.73888,20.0080848 5.73888,15.04125 C5.73888,10.0744152 9.76529517,6.048 14.73213,6.048 Z",
    id: "Rectangle",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.56513,9.072 L16.29663,9.072 C19.5585618,9.072 22.20288,11.7163182 22.20288,14.97825 C22.20288,18.2401818 19.5585618,20.8845 16.29663,20.8845 L15.56513,20.8845 C12.3031982,20.8845 9.65888,18.2401818 9.65888,14.97825 C9.65888,11.7163182 12.3031982,9.072 15.56513,9.072 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73213,29.673 L54.73027,29.673 C59.6971048,29.673 63.72352,33.6994152 63.72352,38.66625 C63.72352,43.6330848 59.6971048,47.6595 54.73027,47.6595 L14.73213,47.6595 C9.76529517,47.6595 5.73888,43.6330848 5.73888,38.66625 C5.73888,33.6994152 9.76529517,29.673 14.73213,29.673 Z",
    id: "Rectangle",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.56513,32.697 L16.29663,32.697 C19.5585618,32.697 22.20288,35.3413182 22.20288,38.60325 C22.20288,41.8651818 19.5585618,44.5095 16.29663,44.5095 L15.56513,44.5095 C12.3031982,44.5095 9.65888,41.8651818 9.65888,38.60325 C9.65888,35.3413182 12.3031982,32.697 15.56513,32.697 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73213,53.298 L54.73027,53.298 C59.6971048,53.298 63.72352,57.3244152 63.72352,62.29125 C63.72352,67.2580848 59.6971048,71.2845 54.73027,71.2845 L14.73213,71.2845 C9.76529517,71.2845 5.73888,67.2580848 5.73888,62.29125 C5.73888,57.3244152 9.76529517,53.298 14.73213,53.298 Z",
    id: "Rectangle",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.56513,56.322 L16.29663,56.322 C19.5585618,56.322 22.20288,58.9663182 22.20288,62.22825 C22.20288,65.4901818 19.5585618,68.1345 16.29663,68.1345 L15.56513,68.1345 C12.3031982,68.1345 9.65888,65.4901818 9.65888,62.22825 C9.65888,58.9663182 12.3031982,56.322 15.56513,56.322 Z",
    id: "Rectangle",
    fill: "#BFE7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(216.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L32,0 C35.3137085,-6.08718376e-16 38,2.6862915 38,6 L38,26 C38,29.3137085 35.3137085,32 32,32 L6,32 C2.6862915,32 4.05812251e-16,29.3137085 0,26 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "Rectangle",
    fill: "#98EFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5294118,11.974853 L14.5294118,19.9937741 C14.5294118,20.4447035 14.8949623,20.8102541 15.3458918,20.8102541 C15.4760618,20.8102541 15.6043453,20.779131 15.7200435,20.7194807 L23.7021129,16.604174 C24.1029095,16.3975357 24.260306,15.9051124 24.0536677,15.5043157 C23.9731703,15.3481825 23.8444644,15.2221738 23.6866615,15.1450006 L15.7045922,11.2413862 C15.2995096,11.0432814 14.8105297,11.2110701 14.6124249,11.6161526 C14.5578046,11.7278396 14.5294118,11.8505254 14.5294118,11.974853 Z",
    id: "Path-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 3.91176471,
    y: 2.80701754,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 10.6176471,
    y: 2.80701754,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 17.3235294,
    y: 2.80701754,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 24.0294118,
    y: 2.80701754,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 30.7352941,
    y: 2.80701754,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 3.91176471,
    y: 25.2631579,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 10.6176471,
    y: 25.2631579,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 17.3235294,
    y: 25.2631579,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 24.0294118,
    y: 25.2631579,
    width: 3.35294118,
    height: 3.36842105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 30.7352941,
    y: 25.2631579,
    width: 3.35294118,
    height: 3.36842105
  })), /*#__PURE__*/React.createElement("g", {
    id: "Men3.6",
    transform: "translate(62.500000, 131.000000) scale(-1, 1) translate(-62.500000, -131.000000) translate(0.500000, 22.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head1",
    transform: "translate(69.201646, 7.036316) scale(-1, 1) translate(-69.201646, -7.036316) translate(57.620963, 0.562905)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(69.979237, 83.866778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.831164883 C0,0.831164883 10.616932,59.2857299 12.4785839,65.3728771 C13.7196851,69.4309753 16.0611987,86.7214404 19.5031247,117.244272 L30.6550495,117.276156 C30.8134527,93.7799893 30.51715,80.1438279 29.7661415,76.3676713 C28.6396287,70.7034366 26.0967551,61.3748201 26.0967551,61.3748201 C26.0967551,61.3748201 24.2074464,27.5092488 23.0771271,19.6093345 C21.947194,11.7094201 18.319514,0 18.319514,0 L0,0.831164883 Z",
    id: "Path",
    fill: "#33373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08026946,44.1938309 L7.06139248,36.2375876 L7.80683088,38.4281564 C11.5182484,49.402528 14.0417775,57.9213533 15.377418,63.9846324 C16.5014266,69.087186 16.7377354,77.89622 16.0863444,90.4117344 L15.3459351,84.2790894 C14.278414,75.5942026 13.2404952,67.9723945 12.5066579,65.466718 L12.4341412,65.2233797 C11.7445172,62.8433718 10.0265072,54.3077095 8.08026946,44.1938309 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(47.874061, 84.378560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2721803,27.6246884 C29.3650933,37.9757696 26.9954996,63.2531868 26.9954996,63.2531868 C26.9954996,63.2531868 26.7279391,65.9159928 27.8860626,73.2925812 C28.658145,78.2103067 27.5230813,92.6338393 24.4808716,116.563179 L12.4697188,116.587366 C11.4820433,84.4405618 10.9647779,66.6766113 10.9179226,63.2955147 C10.8082504,55.3879043 8.21103712,0.561805893 8.21103712,0.561805893 L33.1916509,0 C33.1916509,0 35.1792674,17.2736072 32.2721803,27.6246884 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7575947,21.3102927 L14.7104377,21.5128899 C12.9849073,28.678123 15.9441175,60.4326413 15.1016535,67.9830343 L14.7661183,70.6843963 C14.1804834,75.5388217 13.1894986,84.3885378 11.7931641,97.2335446 L11.4902814,86.4816251 C11.2122792,76.2639321 10.9759141,66.6493375 10.9247763,63.7249799 L10.9179226,63.2955147 C10.8082504,55.3879043 8.21103712,0.561805893 8.21103712,0.561805893 L12.8843147,0.457297655 L13.088654,1.34404033 C15.1515605,10.4286858 15.7078741,17.0841033 14.7575947,21.3102927 L14.7575947,21.3102927 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(57.056051, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96892091,13.0190971 C2.38158257,13.3011544 2.56501328,17.8336966 5.71461499,18.0703477 C6.35836022,22.4397353 8.65414028,24.5214955 11.4530997,24.7623794 L11.2978594,31.3712946 L23.6784665,31.3639835 C23.6784665,31.3639835 20.1921246,26.6952226 20.3659011,20.3037185 C20.5396775,13.9118297 20.2492777,7.90743303 20.2492777,7.90743303 L4.21357259,8.19410795 L4.96892091,13.0190971 Z",
    id: "Path",
    fill: "#FBCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0368506,10.3266373 C20.1524636,10.8636462 19.2642999,13.2905428 18.6993885,13.2905428 C16.1078074,12.2693167 13.9591935,15.9463627 12.8669489,19.6393638 C9.76504005,22.6718233 2.91137955,22.7389857 2.20331425,20.2022692 C-0.477366303,14.6462682 -0.608843948,6.61252493 2.51940093,5.99255871 C0.063783971,-0.463851609 33.2271441,-3.84128352 19.0368506,10.3266373 Z",
    id: "Path",
    fill: "#33373E",
    transform: "translate(11.381924, 11.218620) scale(-1, 1) translate(-11.381924, -11.218620) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49648109,20.5460441 C6.62381007,20.2677259 7.38335159,22.1734907 8.61113307,23.1950878 C9.88170247,24.2522872 11.7889669,24.561883 11.4530997,24.7623794 C8.87536306,26.3011634 5.45874431,22.8143494 6.49648109,20.5460441 Z",
    id: "Path-45",
    fill: "url(#linearGradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(82.477064, 24.204929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1305439,19.5011535 C29.1305439,19.5011535 28.5891337,15.8263273 28.7609793,13.4082531 C29.0787971,8.93612431 28.4709657,5.16355926 29.453382,4.57674146 C30.7134543,3.82407548 31.028569,10.5014848 31.028569,10.5014848 C31.028569,10.5014848 38.2248451,-1.30721328 39.7251152,0.119619772 C41.2253852,1.54606802 38.0958643,7.75171435 38.5920927,9.54603002 C39.088321,11.3399609 34.1295133,20.0187076 34.1295133,20.0187076 L29.1305439,19.5011535 Z",
    id: "Path",
    fill: "#FBCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52851308,21.6240871 C2.52851308,21.6240871 13.4289309,38.714915 15.8370864,42.0295698 C18.3630237,45.5054552 22.8240584,47.0446494 25.9898793,41.4993174 C28.7899972,36.5935206 34.7856711,24.3092115 35.544495,20.4904706 C36.1106201,17.6414221 30.3118928,13.3947852 27.5249046,17.6521964 C24.7379165,21.9092229 20.3363519,28.3111165 20.3363519,28.3111165 C20.3363519,28.3111165 13.0983695,15.093286 10.8419787,11.9744937 C4.75709958,3.56395166 -4.51406742,11.1163929 2.52851308,21.6240871 Z",
    id: "Path",
    fill: "#52C686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000",
    points: "20.3363519 28.3111165 22.7313776 32.4677105 21.8586337 26.0519641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.657466,18.0274302 C30.1273529,17.0457099 32.4704206,17.3124727 34.5353967,20.3169342",
    id: "Path-54",
    stroke: "#5386BF",
    strokeLinecap: "round",
    transform: "translate(31.096431, 18.916925) rotate(4.000000) translate(-31.096431, -18.916925) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(53.426020, 27.486462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3552081,1.22170957 L13.5313265,1.30401675 L13.0064153,1.51365043 C10.8909587,2.37407834 3.03449152,5.72461978 1.57085744,8.59399365 C-0.87477692,13.3885249 2.34741177,51.8021475 0.942712925,54.1201891 C-2.02049956,59.010286 1.85027608,62.3824553 14.7119129,63.6582765 L15.1044137,63.6962955 C28.2796565,64.942166 39.9682963,63.9219212 37.8472614,57.3302318 C35.7256779,50.7379907 42.2168639,8.27959565 36.1298568,5.34677508 C29.6134243,2.59673141 26.3552081,1.22170957 26.3552081,1.22170957 Z",
    id: "Path",
    fill: "#5FDA96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5252057,10.9504733 C14.4250739,15.0527973 10.651468,25.7288866 1.20438793,42.9787412 L1.08751509,39.1253557 C0.77851135,29.5064324 0.323899244,17.7816805 0.894480018,11.8813046 C6.86140837,7.40228014 10.7380567,7.09154026 12.5252057,10.9504733 Z",
    id: "Path",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6686137,0.0958989305 C13.4664089,-0.119873663 26.8255535,0.0958989305 27.3563101,0.0958989305 C27.8870667,0.0958989305 27.8870667,2.3475202 27.3563101,2.3475202 C27.0317589,2.3475202 22.8887551,2.28619991 12.6676532,2.16355933 C12.0527721,2.15618152 10.9251732,2.49732589 9.28485645,3.18699244 C11.0088312,1.27011183 12.1367503,0.239747326 12.6686137,0.0958989305 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 32.085603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3430821,34.5688559 C14.3430821,34.5688559 7.35611004,35.6678406 6.03811217,34.5884807 C4.72011429,33.5095055 -0.529865517,26.1729362 0.043596787,24.9104121 C0.617059091,23.6482729 5.40711055,26.3180053 5.81529213,25.5153155 C6.34009703,24.4840553 3.63111517,20.8049963 6.00490156,20.5906635 C6.61620851,20.5352525 7.04794646,22.7997921 8.76910571,24.2912713 C10.4898788,25.7831353 14.6439084,29.0920181 14.6439084,29.0920181 L14.3430821,34.5688559 Z",
    id: "Path",
    fill: "#FBCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5671198,2.27271303 C50.5289672,7.96465329 41.9793862,21.4052821 40.1578228,22.5893072 C38.3358732,23.7737172 15.547215,26.1620226 13.401655,28.0898634 C11.6094405,29.7002454 11.4480215,34.6000246 13.401655,35.9591331 C15.3556747,37.3182416 41.0130788,35.4962754 45.7185591,34.1379365 C50.4244255,32.7799824 58.4844533,20.3335631 62.0847153,16.4486919 C72.153333,5.584126 62.6052723,-3.41884243 56.5671198,2.27271303 Z",
    id: "Path",
    fill: "#52C686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7722958,27.3009079 C14.6439084,28.6085575 14.0746769,30.5143666 14.6439084,34.2375093",
    id: "Path-53",
    stroke: "#5386BF",
    strokeLinecap: "round"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalization);
export default __webpack_public_path__ + "static/media/personalization.a7646583f63ee130e6994f3fb846183b.svg";
export { ForwardRef as ReactComponent };